import { useSessionStorageValue } from "@react-hookz/web";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { AnimatedCheck } from "~/components/animated-check/animated-check";
import { Button } from "~/components/ui/button";
import type { BrandMatch } from "~/routes/root";

export const OnboardingStepThankYou: React.FC = () => {
  const navigate = useNavigate();
  const { brandId = "" } = useParams<BrandMatch>();
  const { value: redirectUri } = useSessionStorageValue<string>("redirectUri");
  const { t } = useTranslation();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-10">
      <div className="flex flex-col items-center gap-6">
        <AnimatedCheck className="size-24" />
        <div className="flex flex-col gap-2">
          <div className="text-center text-[32px] font-bold leading-[40px] text-gray-900">
            {t("onboarding.thank_you.ready_to_start")}
          </div>
          <p className="text-sm text-gray-700">
            {t("onboarding.thank_you.info_saved")}
          </p>
        </div>
      </div>
      <Button
        type="button"
        size="lg"
        onClick={() => {
          if (redirectUri) {
            navigate(redirectUri, { replace: true });
          } else {
            navigate(`/${brandId}/home`, { replace: true });
          }
        }}
      >
        {t("onboarding.thank_you.access_dashboard")}
      </Button>
    </div>
  );
};
